import { CSSProperties, ReactNode } from "react";
import { Colors } from "../../utils/colors";

type LabelButtonProps = {
  color: string;
  backgroundColor: string;
  text: string | ReactNode;
  subtext?: string;
  icon?: ReactNode;
  borderColor?: string;
  containerStyles?: CSSProperties;
  onPress?: () => void;
};

// Used for displaying labels within ticket items and profile items (subscribed status, ticket status)
const LabelButton = (props: LabelButtonProps) => {
  const {
    color,
    backgroundColor,
    text,
    subtext,
    icon,
    borderColor,
    containerStyles,
    onPress,
  } = props;

  return (
    <div
      className="AlignedRow"
      style={{
        color: color,
        backgroundColor: backgroundColor,
        borderRadius: 100,
        fontSize: 12,
        fontWeight: 500,
        paddingBlock: 7,
        paddingInline: 10,
        gap: 7,
        display: "inline-flex",
        width: "fit-content",
        border: `0.5px solid ${borderColor || Colors.GRAY11}`,
        cursor: onPress ? "pointer" : "auto",
        ...containerStyles,
      }}
      onClick={onPress}
      onMouseEnter={(e) =>
        onPress ? (e.currentTarget.style.opacity = "0.7") : undefined
      }
      onMouseLeave={(e) =>
        onPress ? (e.currentTarget.style.opacity = "1") : undefined
      }
    >
      {icon}
      <div className="ColumnNormal" style={{ gap: 2 }}>
        {typeof text === "string" ? (
          <span className="OneLineText">{text}</span>
        ) : (
          text
        )}
        {subtext ? <span className="smallBodySubtext">{subtext}</span> : null}
      </div>
    </div>
  );
};

export default LabelButton;
